<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fluid grid-list-xs class="home-calendar">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout row align-center>
            <v-flex xs12 class="text-center">
                <v-container fluid>
                    <v-layout row align-center justify-center>
                        <v-flex
                            xs6
                            sm7
                            md8
                            class="display-1 cyan--text text--darken-2"
                        >{{ calendarTitle }}</v-flex>
                        <v-flex xs6 sm5 md4>
                            <v-btn
                                text
                                class="text-none"
                                color="cyan darken-2"
                                @click="onNewDate"
                            >Nueva Cita</v-btn>
                            <v-btn
                                text
                                class="text-none"
                                color="cyan darken-2"
                                @click="onEditDate"
                            >Editar Cita</v-btn>
                            <v-btn
                                text
                                class="text-none"
                                color="cyan darken-2"
                                @click="onDeleteDate"
                            >Borrar Cita</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row align-center justify-start>
                        <v-flex xs6 sm4 md2 class="text-xs-center">
                            <v-select
                                color="cyan darken-2"
                                v-model="calendarType"
                                :items="calendarTypeLabels"
                                label="Vista"
                                item-text="label"
                                item-value="name"
                                item-color="cyan darken-2"
                                @change="onCalendarTypeChanged"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row align-center justify-center>
                        <v-flex xs12>
                            <!-- Container para el calenario: -->
                            <v-container pa-2 grid-list-md>
                                <v-layout row justify-space-between>
                                    <v-flex xs1 class="text-sm-left text-xs-center">
                                        <v-btn text icon color="cyan darken-2" @click="prev">
                                            <v-icon large>mdi-menu-left</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs5 class="text-xs-right">
                                        <h3 class="gmp-green">{{ dateRange }} &nbsp; &nbsp;</h3>
                                    </v-flex>
                                    <v-flex xs2 class="text-xs-center">
                                        <v-btn
                                            rounded
                                            text
                                            color="cyan darken-2"
                                            class="text-none"
                                            @click="setToday"
                                        >
                                            Hoy
                                            <v-icon large>mdi-calendar-today</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex xs1 class="text-sm-right text-xs-center">
                                        <v-btn text icon color="cyan darken-2" @click="next">
                                            <v-icon large>mdi-menu-right</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex xs12 class="mb-3">
                                        <v-sheet height="500">
                                            <!-- :event-color="getEventColor" -->
                                            <v-calendar
                                                ref="calendar"
                                                v-model="todayDate"
                                                :now="today"
                                                :value="todayDate"
                                                color="cyan darken-2"
                                                locale="es-MX"
                                                :short-weekdays="false"
                                                :events="events"
                                                :event-margin-bottom="3"
                                                :type="calendarType"
                                                @click:event="showEvent"
                                                @click:more="viewDay"
                                                @click:date="viewDay"
                                                @change="onCalendarChange"
                                                event-color="primary"
                                                event-text-color="red"
                                            >
                                                <!-- the events at the top (all-day) -->
                                                <!-- dayHeader es el espacio en donde está el día del mes en vista de día y semana -->
                                                <template v-slot:dayHeader="{ date }">
                                                    <template v-for="event in eventsMap[date]">
                                                        <div
                                                            v-if="!event.time"
                                                            :key="event.title"
                                                            class="my-all-day-event-day-week"
                                                            @click="open(event)"
                                                            v-html="event.title"
                                                        ></div>
                                                    </template>
                                                </template>

                                                <!-- the timed events -->
                                                <!-- dayBody es el espacio de las horas en vista de día y semana  -->
                                                <template
                                                    v-slot:dayBody="{ date, timeToY, minutesToPixels }"
                                                >
                                                    <template v-for="event in eventsMap[date]">
                                                        <div
                                                            v-if="event.time || event.duration || (event.start && event.end)"
                                                            :key="event.title"
                                                            :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                                                            class="my-timed-event-day-week"
                                                            @click="open(event)"
                                                            v-html="event.title"
                                                        ></div>
                                                    </template>
                                                </template>

                                                <!-- the events at the top (all-day) -->
                                                <!-- (eventos de todo el día): -->
                                                <!-- v-if="!event.time" -->
                                                <template v-slot:day="{ date }">
                                                    <template v-for="event in eventsMap[date]">
                                                        <v-menu
                                                            :key="event.title"
                                                            v-model="event.open"
                                                            full-width
                                                            offwet-x
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <div
                                                                    v-ripple
                                                                    class="my-event-month"
                                                                    v-on="on"
                                                                    v-html="event.title"
                                                                ></div>
                                                            </template>
                                                            <v-card
                                                                color="gray lighten-4"
                                                                min-width="350px"
                                                                flat
                                                            >
                                                                <v-toolbar
                                                                    color="deep-purple darken-1"
                                                                    dark
                                                                >
                                                                    <v-btn icon>
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                    <v-toolbar-title
                                                                        v-html="event.title"
                                                                    ></v-toolbar-title>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn icon>
                                                                        <v-icon>time_to_leave</v-icon>
                                                                    </v-btn>
                                                                    <v-btn icon>
                                                                        <v-icon>more_vert</v-icon>
                                                                    </v-btn>
                                                                </v-toolbar>
                                                                <v-card-title primary-title>
                                                                    <span v-html="event.details"></span>
                                                                </v-card-title>
                                                                <v-card-actions>
                                                                    <v-btn
                                                                        flat
                                                                        color="secondary"
                                                                    >Cancelar</v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-menu>
                                                    </template>
                                                </template>
                                            </v-calendar>
                                        </v-sheet>
                                    </v-flex>
                                </v-layout>
                                <!-- **************   Modal para para una nueva cita: ***********************  -->
                                <v-layout justify-center>
                                    <v-dialog v-model="bNewDate" persistent max-width="50%">
                                        <v-card>
                                            <v-toolbar dense dark color="cyan darken-2" flat>
                                                <v-icon>date_range</v-icon>
                                                <v-toolbar-title
                                                    class="my-list-title"
                                                >&nbsp Agendar Nueva Cita</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="onCancelDate" rounded small>
                                                    <v-icon>cancel</v-icon>
                                                </v-btn>
                                            </v-toolbar>

                                            <v-card-text>
                                                <v-container fluid grid-list-md>
                                                    <v-layout row wrap>
                                                        <v-switch
                                                            v-model="bAllDayDate"
                                                            label="Todo el día"
                                                            color="cyan darken-3"
                                                            @change="onAllDayDate"
                                                        ></v-switch>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 text-xs-center>
                                                            <v-radio-group
                                                                v-model="dateType"
                                                                row
                                                                :disabled="bAllDayDate"
                                                            >
                                                                <v-radio
                                                                    label="Normal"
                                                                    vaule="serviceDate"
                                                                    color="cyan darken-3"
                                                                ></v-radio>
                                                                <v-radio
                                                                    label="Prenatal"
                                                                    vaule="preSaleDate"
                                                                    color="cyan darken-3"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout wrap justify-space-around row>
                                                        <v-flex xs12 sm6 md4>
                                                            <v-dialog
                                                                ref="dialogDateFrom"
                                                                v-model="bModalDateFrom"
                                                                :return-value.sync="dtDateFrom"
                                                                persistent
                                                                full-width
                                                                width="290px"
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="dtDateFrom"
                                                                        label="Fecha de Inicio"
                                                                        prepend-icon="event"
                                                                        readonly
                                                                        v-on="on"
                                                                        color="cyan darken-3"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="dtDateFrom"
                                                                    scrollable
                                                                    locale="es-MX"
                                                                    color="cyan darken-2"
                                                                >
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        text
                                                                        color="cyan darken-3"
                                                                        class="text-none"
                                                                        @click="$refs.dialogDateFrom.save(dtDateFrom)"
                                                                    >OK</v-btn>
                                                                    <v-btn
                                                                        text
                                                                        color="pink darken-1"
                                                                        class="text-none"
                                                                        @click="bModalDateFrom = false"
                                                                    >Cancelar</v-btn>
                                                                </v-date-picker>
                                                            </v-dialog>
                                                        </v-flex>
                                                        <v-flex xs11 sm5>
                                                            <v-dialog
                                                                ref="dialogTimeFrom"
                                                                v-model="bModalTimeFrom"
                                                                :return-value.sync="dtTimeFrom"
                                                                persistent
                                                                full-width
                                                                width="290px"
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="dtTimeFrom"
                                                                        label="Hora"
                                                                        prepend-icon="access_time"
                                                                        readonly
                                                                        v-on="on"
                                                                        :disabled="bAllDayDate"
                                                                        color="cyan darken-2"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="bModalTimeFrom"
                                                                    v-model="dtTimeFrom"
                                                                    full-width
                                                                    color="cyan darken-2"
                                                                >
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        text
                                                                        color="cyan darken-3"
                                                                        class="text-none"
                                                                        @click="$refs.dialogTimeFrom.save(dtTimeFrom)"
                                                                    >OK</v-btn>
                                                                    <v-btn
                                                                        text
                                                                        color="pink darken-1"
                                                                        class="text-none"
                                                                        @click="bModalTimeFrom = false"
                                                                    >Cancelar</v-btn>
                                                                </v-time-picker>
                                                            </v-dialog>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout wrap justify-space-around row>
                                                        <v-flex xs12 sm6 md4>
                                                            <v-menu
                                                                v-model="bMenuDateTo"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                min-width="290px"
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="dtDateTo"
                                                                        label="Fecha de Fin"
                                                                        prepend-icon="event"
                                                                        readonly
                                                                        v-on="on"
                                                                        color="cyan darken-2"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="dtDateTo"
                                                                    @input="bMenuDateTo = false"
                                                                    locale="es-MX"
                                                                    color="cyan darken-2"
                                                                ></v-date-picker>
                                                            </v-menu>
                                                        </v-flex>
                                                        <v-flex xs11 sm5>
                                                            <v-dialog
                                                                ref="dialogTimeTo"
                                                                v-model="bModalTimeTo"
                                                                :return-value.sync="dtTimeTo"
                                                                persistent
                                                                full-width
                                                                width="290px"
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="dtTimeTo"
                                                                        label="Hora"
                                                                        prepend-icon="access_time"
                                                                        readonly
                                                                        v-on="on"
                                                                        :disabled="bAllDayDate"
                                                                        color="cyan darken-2"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="bModalTimeTo"
                                                                    v-model="dtTimeTo"
                                                                    full-width
                                                                    color="cyan darken-2"
                                                                >
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn
                                                                        text
                                                                        color="cyan darken-3"
                                                                        class="text-none"
                                                                        @click="$refs.dialogTimeTo.save(dtTimeTo)"
                                                                    >OK</v-btn>
                                                                    <v-btn
                                                                        text
                                                                        color="pink darken-1"
                                                                        class="text-none"
                                                                        @click="bModalTimeTo = false"
                                                                    >Cancelar</v-btn>
                                                                </v-time-picker>
                                                            </v-dialog>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout wrap justify-space-around row>
                                                        <v-flex xs12>
                                                            <v-textarea
                                                                v-model="dateText"
                                                                auto-grow
                                                                outlined
                                                                color="cyan darken-3"
                                                                label="Detalles"
                                                                rows="2"
                                                            ></v-textarea>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row>
                                                        <v-spacer></v-spacer>

                                                        <v-btn
                                                            text
                                                            color="cyan darken-3"
                                                            class="text-none"
                                                            @click="onSaveDate"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            text
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            @click="onCancelDate"
                                                        >Cancelar</v-btn>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-dialog>
                                </v-layout>
                                <!-- **************   Fin Modal para una nueva cita ***********************  -->
                                <v-overlay :value="waitCursor">
                                    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                                </v-overlay>

                                <!-- Termina renglón para calendario -->
                            </v-container>
                            <!-- Termina container para calendario -->
                        </v-flex>
                        <!-- Fin Flex para la ventana **************************************************************** -->
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'HomeCalendar',
    data: () => ({
        dateText: '',
        dateType: null,
        bAllDayDate: null,
        bModalDateFrom: false,
        bMenuDateTo: false,
        bModalTimeFrom: false,
        bModalTimeTo: false,
        dtDateFrom: null,
        dtDateTo: null,
        dtTimeFrom: null,
        dtTimeTo: null,
        bNewDate: false,
        today: '',
        todayDate: '',
        calendarType: 'month',
        calendarTypeLabels: [
            {
                name: 'month',
                label: 'Mes'
            },
            {
                name: 'week',
                label: 'Semana'
            },
            {
                name: 'day',
                label: 'Día'
            },
            {
                name: '4day',
                label: '4 Días'
            }
        ],
        now: null,
        start: null,
        end: null,
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        months: [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre'
        ],
        events: [
            {
                title: 'Llamar a Federico Pérez',
                details: 'Seguimiento de preventa - Chevrolet Camaro',
                start: '2019-09-20',
                open: false
            },
            {
                title: 'Silvia González',
                details: 'Preventa - Chevrolet Aveo',
                start: '2019-09-21',
                time: '11:00',
                duration: 60,
                open: false
            },
            {
                title: 'Llamar a Julieta Ramírez',
                details: 'Seguimiento de postventa - Chevrolet Blazer',
                start: '2019-09-22',
                open: false
            },
            {
                title: 'Juan Pérez',
                details: 'Seguimiento - Chevrolet Blazer',
                start: '2019-09-23',
                time: '09:00',
                duration: 30,
                open: false
            },
            {
                title: 'Alfonso Trejo González',
                details: 'Preventa - Chevrolet Camaro',
                start: '2019-09-24',
                time: '09:30',
                duration: 30,
                open: false
            },
            {
                title: 'Jaime Rodríguez',
                details: 'Prueba de Manejo - Chevrolet Corvette',
                start: '2019-09-25',
                time: '13:00',
                duration: 60,
                open: false
            },
            {
                title: 'Llamar a Sergio Jiménez',
                details: 'Pedir documentación',
                start: '2019-09-26',
                open: false
            },
            {
                title: 'Jorge Álvarez',
                details: 'Servicio - Chevrolet Aveo',
                start: '2019-09-27',
                time: '11:30',
                duration: 60,
                open: false
            },
            {
                title: 'Jorge Islas',
                details: 'Cierre de Venta - Chevrolet Aveo',
                start: '2019-09-28',
                time: '12:30',
                duration: 60,
                open: false
            }
        ]
    }),
    created() {
        this.now = new Date();
        var dd = String(this.now.getDate()).padStart(2, '0');
        var mm = String(this.now.getMonth() + 1).padStart(2, '0');
        var yyyy = this.now.getFullYear();
        this.today = yyyy + '-' + mm + '-' + dd;
        this.todayDate = this.today;

        console.log('BreakPoint: ', this.$vuetify.breakpoint);
    },

    computed: {
        ...mapGetters(['selectedUserName', 'waitCursor']),

        calendarTitle() {
            return 'Agenda de ' + this.selectedUserName;
        },

        // convert the list of events into a map of lists keyed by date:
        eventsMap() {
            const map = {};
            this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
            return map;
        },

        dateRange() {
            var strDateRange = '';
            if (this.start !== null && this.end !== null) {
                var dayFrom = this.start.day;
                var dayTo = this.end.day;
                var monthFrom = this.months[this.start.month - 1];
                var monthTo = this.months[this.end.month - 1];
                var yearFrom = this.start.year;
                var yearTo = this.end.year;

                if (this.calendarType === 'month') {
                    strDateRange = monthFrom + ' ' + yearFrom;
                } else if (this.calendarType === 'week') {
                    if (yearFrom === yearTo) {
                        if (monthFrom === monthTo) {
                            strDateRange =
                                dayFrom +
                                ' - ' +
                                dayTo +
                                ' de ' +
                                monthFrom +
                                ' de ' +
                                yearFrom;
                        } else {
                            strDateRange =
                                dayFrom +
                                ' de ' +
                                monthFrom +
                                ' - ' +
                                dayTo +
                                ' de ' +
                                monthTo +
                                ' de ' +
                                yearFrom;
                        }
                    } else {
                        strDateRange =
                            dayFrom +
                            ' de ' +
                            monthFrom +
                            ' de ' +
                            yearFrom +
                            ' - ' +
                            dayTo +
                            ' de ' +
                            monthTo +
                            ' de ' +
                            yearTo;
                    }
                } else if (this.calendarType === 'day') {
                    strDateRange =
                        dayFrom + ' de ' + monthFrom + ' de ' + yearFrom;
                }
            } else if (this.now !== null) {
                //Esto sucede cuando se inicia la página
                strDateRange =
                    this.months[this.now.getMonth()] +
                    ' ' +
                    this.now.getFullYear();
            }
            //console.log('strTitle = ', strTitle);
            return strDateRange;
        }
    },
    methods: {
        onAllDayDate() {
            if (this.bAllDayDate) {
                this.dtTimeFrom = null;
                this.dtTimeTo = null;
                this.dateType = null;
            }
        },
        open(event) {
            alert(event.title);
        },
        viewDay({ date }) {
            this.todayDate = date;
            this.calendarType = 'day';
            console.log('viewDay, date = ', date);
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.todayDate = this.today;
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                setTimeout(() => (this.selectedOpen = true), 10);
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                setTimeout(open, 10);
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        onCalendarChange({ start, end }) {
            // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
            this.start = start;
            this.end = end;
            // console.log('onCalendarChange, start = ', this.start.date);
            // console.log('end = ', this.end.date);
            // console.log('todayDate = ', this.todayDate);
        },
        nth(d) {
            return d > 3 && d < 21
                ? 'th'
                : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][
                      d % 10
                  ];
        },
        onCalendarTypeChanged() {
            console.log('todayDate = ', this.todayDate);
            console.log('type = ', this.calendarType);
            //if (this.calendarType === 'day' || this.calendarType === 'week') {
            //Al parecer la siguiente línea sólo funciona cuando se cambia
            //de semana a día o de día a semana:
            this.$refs.calendar.scrollToTime('08:00');
            //}
        },
        onNewDate() {
            this.bNewDate = true;
        },
        onCancelDate() {
            this.bNewDate = false;
        },
        onSaveDate() {
            this.bNewDate = false;
        },
        onEditDate() {},
        onDeleteDate() {}
    }
};
</script>

<style scoped>
.home-calendar {
    background: url('../assets/background1.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-all-day-event-day-week {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1e88e5;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
        position: relative;
        right: 4px;
        margin-right: 0px;
        background-color: #1867aa;
    }
}

.my-timed-event-day-week {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #5e35b1;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 0px;
    position: absolute;
    right: 4px;
}

.my-event-month {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 4px;
    background-color: #5e35b1;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;
}

.gmp-green {
    color: #0097a7;
}
</style>
